import jwt from 'jsonwebtoken';
import { ReactElement, ReactNode, useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getAxiosBaseURL, requestInterceptor, responseInterceptor } from '../api/Interceptors';
import AuthContext from '../contexts/AuthContext';
import { AuthContextValue } from "../models/users/AuthContext";
import { checkUrlByRoles } from '../utils/urls';
import { canVerDashboardPlanificaciones } from '../utils/planificaciones';
import JWT from '../models/users/JWT';


interface AuthStoreProps {
    children?: ReactNode;
}

const AuthStore = ({ children }: AuthStoreProps): ReactElement => {
    const history = useHistory();
    const location = useLocation();
    const [jwtState, setJwtState] = useState<JWT>();
    const [previuosLocation, setPreviuosLocation] = useState<string>();
    const [currentAxiosBaseURL, setCurrentAxiosBaseURL] = useState<string>();

    const setToken = useCallback(
        (jwtString: string): void => {
            localStorage.setItem('jwt', jwtString);
            setJwtState(jwt.decode(jwtString) as JWT);
        }, []
    );

    const logout = useCallback((): void => {
        setPreviuosLocation('no guardar');
        localStorage.removeItem('jwt');
        setJwtState(undefined);
        history.push('/login');
    }, []
    );

    const onChangePreviuosLocation = (previuosLocation: string): void => {
        setPreviuosLocation(previuosLocation);
    }

    const savePreviousLocationAndRedirectToLogin = (): void => {
        if (location.pathname !== '/' && location.pathname !== '/login' && previuosLocation !== 'no guardar') {
            onChangePreviuosLocation(location.pathname);
        }
        history.replace('/login');
    }

    getAxiosBaseURL(setCurrentAxiosBaseURL, currentAxiosBaseURL);
    requestInterceptor(savePreviousLocationAndRedirectToLogin);
    responseInterceptor();

    useEffect(() => {
        getAxiosBaseURL(setCurrentAxiosBaseURL, currentAxiosBaseURL);
        if (!['/login', '/setup-2fa', '/cambiar-contrasena'].includes(location.pathname)) {
            const localJwt = localStorage.getItem('jwt');
            if (localJwt) {
                const decodedLocalJWT = jwt.decode(localJwt) as JWT;
                if (decodedLocalJWT?.mustChangePassword) {
                    // Entró con contraseña temporal: el backend rechaza ese token en todo lo demás
                    history.replace('/cambiar-contrasena');
                } else if (checkUrlByRoles(decodedLocalJWT.roles, location.pathname)) {
                    if (!jwtState) {
                        setJwtState(decodedLocalJWT);
                    }
                    // El inicio muestra el dashboard de planificaciones a quien puede leerlo; el resto
                    // (salvo el cliente) sigue partiendo en Estatus General. Se usan los roles del token
                    // y no `jwtState`, que en la primera carga todavía no está seteado.
                    const roles = decodedLocalJWT.roles;
                    if (location.pathname === '/' && !roles.includes("CLIENTE") && !canVerDashboardPlanificaciones(roles)) {
                        history.replace('/ordenesProceso')
                    }
                } else {
                    savePreviousLocationAndRedirectToLogin();
                }
            } else {
                savePreviousLocationAndRedirectToLogin();
            }
        }
    }, [location]);

    const authContextValue: AuthContextValue = {
        setJWT: setToken,
        //hasJWT: authState.hasJWT,
        userName: jwtState?.sub || '',
        userEmail: jwtState?.email || '',
        userRut: jwtState?.rut || '',
        userRoles: jwtState?.roles || [],
        authProvider: jwtState?.authProvider || 'LOCAL',
        logout: logout,
        previuosLocation: previuosLocation || '',
        setPreviuosLocation: onChangePreviuosLocation
    };

    return (<AuthContext.Provider value={authContextValue}>{children}</AuthContext.Provider>);
}

export default AuthStore;